
import { defineComponent, ref, computed } from '@nuxtjs/composition-api'
import { Glide, GlideSlide } from 'vue-glide-js'
import breakpointsList from '~/config/carousel'

export default defineComponent({
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  props: {
    entries: { type: Array, required: true, default: () => [] },
    breakpoints: { type: Object, required: false, default: () => breakpointsList.mx3 }, // settings for the mx1, mx2, mx3, mx4 options can be found in carousel.js
    color: { type: String, required: false, default: undefined },
    gap: { type: Number, required: false, default: 32 },
  },
  setup(props) {
    const slider = ref(null)
    const getAmount = () => {
      return props.entries?.length
    }
    const currentSlide = ref(null)
    const getCurrent = computed(() => {
      return currentSlide.value
    })
    const moved = () => {
      currentSlide.value = slider.value.glide._i
    }

    return {
      getAmount,
      getCurrent,
      moved,
      slider,
    }
  },
})
